export const build = {"tag":"v1.0.5","hash":"ff38c4a1","time":"261015.0631"}